import http from "./http_common";
class DiagnosticService {

    AddtoCart(data) {
        return http.post(`/CartDetails/add`, data);
    }

    getCartList(data) {
        return http.get(`/CartHeader/list/filter?userId=${data}&status=1`);
    }

    getMyOrderList(data) {
        return http.get(`BillingDetails/list/filter?userId=${data}&status=1`);
    }

    updateCartQuantity(cartId, productCode, data) {
        return http.put(`/CartDetails/${cartId}/updateQuantity/${productCode}`, data);
    }

    deleteFromCart(cartId, productCode) {
        return http.delete(`/CartDetails/${cartId}/removeOneItem/${productCode}`);
    }

    cashPayment(data) {
        return http.post(`/BillingHeader/cash-payment`, data);
    }

    getRecentOrder(data) {
        return http.get(`/PatientDrugPrescriptionOrder/list?patientId=${data}&status=1`)
    }

    uploadPrescriptionDoc(orderId, data) {
        return http.put(`/PatientCart/UploadPrescriptionDoc/${orderId}`, data);
    }

    getPrescriptionDoc(orderId, orderType){
        return http.get(`/PatientCart/PrescriptionDoc?orderId=${orderId}&orderType=${orderType}`);

    }

    // getCartList(data) {
    //     return http.get(`/PatientCart/list`);
    // }


    // PlaceLabTestOrder(data) {
    //     return http.post(`${ELASTIC_URL}items?type=LAB&page=${data.page}&limit=${data.limit}&lat=${data.lat}&lon=${data.lon}&radius=100&keyword=${data.keyword}`);
    // }
}



export default new DiagnosticService();